// extracted by mini-css-extract-plugin
export var col1 = "gallery-module--col1--lou+A";
export var col1Rtl = "gallery-module--col1-rtl--AM3X+";
export var col2 = "gallery-module--col2--K7pVI";
export var image = "gallery-module--image--SBd9N";
export var images = "gallery-module--images--kVIdb";
export var withGallery = "gallery-module--with-gallery--cPZTe";